import script from "./informations.vue?vue&type=script&setup=true&lang=js"
export * from "./informations.vue?vue&type=script&setup=true&lang=js"

import "./informations.vue?vue&type=style&index=0&id=6cf2774f&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cf2774f"]])

export default __exports__